export const SET_ELCALARM_RECORDS = 'ELCAlarmRecords/set';
